import * as React from 'react'

import { inject, observer } from 'mobx-react'

import DesktopFileInput from '~/client/src/desktop/components/FileInput/DesktopFileInput'
import DesktopInitialState from '~/client/src/desktop/stores/DesktopInitialState'
import DeliveryDetails from '~/client/src/shared/components/DeliveryDetails/DeliveryDetails'
import DeliveryDetailsStore from '~/client/src/shared/components/DeliveryDetails/DeliveryDetails.store'
import { withErrorBoundary } from '~/client/src/shared/components/ErrorBoundary'
import UnsafeWorkflowViewFormWrapper from '~/client/src/shared/components/SitePermitCreationForm/WorkflowViewFormWrapper'
import { EMPTY_STRING } from '~/client/src/shared/utils/usefulStrings'

import DeliveryActionSideBase from '../../../Deliveries/components/DeliveryActionSideWrapper/components/DeliveryActionSideBase'
import AttachmentsStore from '../../Attachments.store'

const WorkflowViewFormWrapper = withErrorBoundary(UnsafeWorkflowViewFormWrapper)

interface IProps {
  store: AttachmentsStore
  state?: DesktopInitialState
  deliveryDetailsStore?: DeliveryDetailsStore
}

const AttachmentDialogsComponent: React.FC<IProps> = ({
  store,
  state,
  deliveryDetailsStore,
}) => {
  const {
    isPermitDialogDisplayed,
    displayedWorkflow,
    hidePermitDialog,
    hideDeliverySideView,
  } = store

  const { displayedDelivery } = deliveryDetailsStore || {}

  return (
    <>
      {isPermitDialogDisplayed && displayedWorkflow && (
        <div className="permit-side-view">
          <WorkflowViewFormWrapper
            key={displayedWorkflow.id}
            workflowToShow={displayedWorkflow}
            onClose={hidePermitDialog}
            FileInputType={DesktopFileInput}
          />
        </div>
      )}
      {displayedDelivery && (
        <DeliveryActionSideBase
          title={EMPTY_STRING}
          content={
            <DeliveryDetails
              initProjectId={state?.activeProject.id}
              FileInputType={DesktopFileInput}
              backClicked={hideDeliverySideView}
              displayedDeliveryId={displayedDelivery?.id}
            />
          }
          shouldShowHeader={false}
        />
      )}
    </>
  )
}

const AttachmentDialogs = inject(
  'state',
  'deliveryDetailsStore',
)(observer(AttachmentDialogsComponent))

export default AttachmentDialogs
